module.exports = __webpack_public_path__ + "static/img/video_snapshot.6a47e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_aboutus/video_snapshot.png
// module id = XiOe
// module chunks = 1